<template>
  <v-app>
    <v-content  v-bind:class="ObjStyle" style="background:#ffffff">
      <router-view></router-view>
    </v-content>
  </v-app>
</template>
<script>
import storejs from 'storejs';
export default {
  name: "App",
  data() {
    return {
      title: "中税网通",
      showbar: true,
      ObjStyle:'',
    };
  },
  created() {
  },
  mounted() {
    const that = this;
    if(this.$route.meta.style == true){
      that.ObjStyle = 'APPstyle';
    }
  },
  methods: {
  },
};
</script>
